import userApi from "@/api/userApi";
import Customer from "./customer";
import _ from "lodash";
import store from "@/store";
import router from "@/router";
import MCartCustomer from "@/model/mCartcustomer";
export interface IUser {
  id?: number;
  login_id: string;
  is_enabled?: boolean;
  created?: string;
  customer?: Customer;
  mail_address?: string;
  login_password?: string;
  login_password_confirmation?: string;
  account_supervisor_name?: string;
  account_authority?: number;
  customer_name?: string;
  account_code?: string;
  customer_code?: string;
  administrator_name?: string;
  m_cart_customer?: MCartCustomer;
}

export class UserDTO implements IUser {
  id?: number;
  login_id = "";
  name = "";
  department_name = "";
  is_enabled? = false;
  created? = "";
  customer?: Customer;
  mail_address? = "";
  login_password? = "";
  login_password_confirmation? = "";
  account_supervisor_name? = "";
  customer_name? = "";
  account_code?: string;
  customer_code?: string;
  administrator_name?: string;
  m_cart_customer?: MCartCustomer;
  account_authority? = 1;
}

export default class User extends UserDTO {
  original = {};
  constructor(dto?: UserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      dto.customer && (dto.customer = new Customer(dto.customer));
    } else {
      this.new();
    }
  }

  get statusName(): string {
    return this.is_enabled ? "on" : "off";
  }

  public new() {
    Object.assign(this, {
      id: null,
      login_id: "",
      mail_address: "",
      login_password: "",
      confirm_login_password: "",
      is_enabled: "",
      customer_name: "",
      customer_code: "",
      account_authority: 1,
      customer: "",
      m_cart_customer: new MCartCustomer(),
    });
  }

  public logout() {
    return new Promise(() => {
      userApi.logout().then((response) => {
        store.dispatch(
          "Auth/updateAuthenticateStatus",
          response.data.data.authenticate_status
        );
        router.push({ name: "login" });
      });
    });
  }
}

export class UserCustomer extends User {
  public delete() {
    return new Promise((resovle, reject) => {
      userApi.deleteUserCustomer(this.account_code).then((response) => {
        if (response.data.meta.status == 200) {
          resovle(response.data);
        } else {
          reject(response.data);
        }
      });
    });
  }

  public save() {
    const dataRequest :any = _.pick(this, [
      "login_id",
      "login_password",
      "mail_address",
      "customer_code",
      "account_authority",
      "account_supervisor_name",
      "account_code",
    ]);
    if (this.customer.customer_code) {
      dataRequest.customer_code = this.customer.customer_code || dataRequest;
    }

    if (this.account_code) {
      return new Promise((resovle, reject) => {
        userApi
          .editUserCustomer(this.account_code, dataRequest)
          .then((response) => {
            if (response.data.meta.status == 200) {
              resovle(response.data);
            } else {
              reject(response.data);
            }
          });
      });
    } else {
      dataRequest.name = this.customer.customer_name;
      return this.create(dataRequest);
    }
  }

  public create(data) {
    return new Promise((resovle, reject) => {
      userApi.addUserCustomer(data).then((response) => {
        if (response.data.meta.status == 200) {
          resovle(response.data);
        } else {
          reject(response.data);
        }
      });
    });
  }

  public changePassword() {
    return new Promise((resovle, reject) => {
      userApi
        .changePassword({
          login_password: this.login_password,
          login_password_confirmation: this.login_password_confirmation,
        })
        .then((response) => {
          if (response.data.meta.status == 200) {
            console.log(response.data);
            resovle(response.data);
          } else {
            reject(response.data);
          }
        });
    });
  }
}
